<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 shape-default" :class="$route.meta.className">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container container-lg pt-5">
        	<div class="row">
				<div class="col-md-12 mb-4  mb-lg-0 col-lg-3">
					<ul role="tablist" class="nav nav-pills nav-fill nav-pills flex-column card-header">
						<li v-for="item in menuList" v-bind:key="item.path" class="nav-item">
							<router-link :to="{name: item.name}" class="nav-link" :class="{active : item.name === $route.name}"  aria-selected="true">
								<div>
									<i class="mr-2 fa"  :class="item.icon"></i>
									<span>{{item.meta.title}}</span>
				                </div>
				            </router-link>
	                    </li>
                	</ul>
                </div>
                <div class="tab-content col-md-12 mb-8  col-lg-9">
                	<keep-alive :include="cacheList">
                	  <router-view/>
                	</keep-alive>
                </div>
        	</div>
        </div>
    </section>
</template>
<script>
export default {
  name: 'Main',
  components: {
  },
  data () {
    return {
      cacheList: []
    }
  },
  computed: {
  	menuList () {
  		let res = []
  		this.$store.getters.menuList.forEach(item => {
		    if (!!~this.$route.name.indexOf(item.name)) {
		    	res = item.children
		    }
  		})
      return res
    },
  },
  methods: {
  },
  watch: {
  },
  mounted () {
  	// console.log(this.$route)
  }
}
</script>
